import {_n} from 'pexui';
import * as utils from '../utilities/utils';
import {track, trackError} from '../utilities/track';
import {DocUploadService} from '../services/docuploadsvc';

// data model of the required documents and we need items tree
export const STATUS_NOT_READY   = 0;
export const STATUS_MAYBE_READY = 1;
export const STATUS_COMPLETED   = 2;

export function getNodeReadyStatus(node){
    if(Array.isArray(node)){
        return utils.reduceArray(node,
            (status, n)=> Math.max(getNodeReadyStatus(n), status),
            STATUS_NOT_READY);
    }else if(node.choices){
        return utils.reduceArray(node.choices,
            (status, n)=> Math.max(getNodeReadyStatus(n), status),
            STATUS_NOT_READY);
    }else if(node.widgetOption){
        return utils.reduceArray(node.widgetOption.document_types,
            (status, dt)=> Math.max(getDocOptionReadyStatus(node, dt), status),
            STATUS_NOT_READY);
    }else{
        // null node.widgetOption
        return STATUS_MAYBE_READY;
    }
}

export function getTrackLabel(node){
    if(!(node && node.widgetOption && node.code)){
        return '';
    }
    const ignores = ['a','the','please','provide','of','your','last'];
    const simplifies = {'months':'M','month':'M','year':'Y','years':'Y'};

    let label = _n(node.widgetOption.content_id + '.name');
    if(!label){
        label = _n(node.widgetOption.content_id + '.title');
        label = label.replace(/^.*:\s*/,'').replace(/[\-\(\{].*$/,'').replace(/(\S+)\s*/g, function(_a,word){
            const lword = word.toLowerCase();
            if(ignores.indexOf(lword)>=0){
                return '';
            }else if(simplifies.hasOwnProperty(lword)){
                return simplifies[lword];
            }else{
                return word;
            }
        });
    }

    if(label){
    }else{
        label = node.code;
    }
    return label;
}

function getDocOptionReadyStatus(node, dt){
    // docOpt = {document_option: 'Yodlee', document_type: '...'}
    if(dt.document_option === 'Yodlee'){
        return dt.done? STATUS_COMPLETED: STATUS_NOT_READY;
    }else if(dt.document_option === 'LinkedIn'){
        return dt.done? STATUS_COMPLETED: STATUS_MAYBE_READY;
    }else if(dt.document_option === 'DocUpload'){
        return getDocOptionReadyStatusDocUpload(node);
    }else{
        return STATUS_MAYBE_READY;
    }
}

function getDocOptionReadyStatusDocUpload(node){
    let status = STATUS_NOT_READY;
    for(var i=0;i<node.files.length;i++){
        const file = node.files[i];
        if(file.type !== 'info'){
            if(file.completedTime){
                status = STATUS_MAYBE_READY;
            }else{
                status = STATUS_NOT_READY;
                // one file not ready, all not ready
                break;
            }
        }
    }
    return status;
}

function buildWeneedTree (tree, nodes, acct, level, key){
    if(tree.op === 'ITEM'){
        nodes.push({
            level: level,
            done: false,
            account: acct,
            code: tree.data,
            messages: [],
            files: [],
            key: key
        });
    }else if(tree.op === 'AND'){
        tree.data.forEach( (item, i) =>{
            buildWeneedTree(item, nodes, acct, level, key + '' + i);
        });
    }else if(tree.op === 'OR'){
        var choices = [];
        tree.data.forEach( (item, i)=>{
            var choice = [];
            buildWeneedTree(item, choice, acct, level + 1, key + '' + i);
            choices.push(choice);
        });
        nodes.push({
            level: level,
            done: false,
            account: acct,
            choices: choices,
            messages: [],
            files: [],
            key: key
        });
    }
}

// nodes of the we need items tree
/*export class WorkFlowNode{
    constructor(props){
        this.level = props.level;
        this.account = props.account;
        this.code = props.code;
        this.widgetOption = props.widgetOption;
        this.choices = [];  // multiple choices node
        this.messages = []; // messages to display
        this.files = [];    // uploaded files {name: , time: }
        this.done = false;
    }
}*/

// work flow
export class GetInfoFlow {
    constructor(){
        this.reset();
    }

    reset(){
        this.config = null;
        this.req = null;
        this.widgetCallback = null;
        this.documents = [];
        this.widgetOptions = [];
        this.allDocOptions = [];
        this.currLevelNodes = [];
        this.currNode;
        this.allWeneedCodes = '';
        this.docupld_token = null;
        this.docUploadTids = {};
        this.stack = []; // stack of the parent nodes of work flow, [{index:prev_index, nodes:prev_nodes}, {index:prev_prev_index, } ...]
        this.nodes = []; // nodes of the we need items tree
        this.lastNodeForYodlee = null;
        this.lastError = '';
        this.lastChannel = '';
    }

    /**
     * @param {*} widget
     * @return {Promise} a Promise
     */
    init(widget){
        this.widget = widget;
        this.config = widget.props.config;
        this.widgetCallback = widget.props.widgetCallback;
        const req = this.req = widget.props.req;
        this.transaction_id = req.transaction_id;

        this.documents = req.document_data.documents_requested;
        this.docUploadTids = {};
        this.widgetOptions = [];
        this.allDocOptions = [];
        this.currLevelNodes = [];
        this.allWeneedCodes = '';
        this.stack = []; // [{index:prev_index, nodes:prev_nodes}, {index:prev_prev_index, } ...]
        this.nodes = [];

        var flow = this;
        var allWeneedCodes = [];
        flow.doc_data = flow.req.document_data;

        flow.documents.forEach( (acct, i)=>{
            utils.mergeArray(allWeneedCodes, utils.getAllWeneedCodes(acct.documents_requested_options_desc));
            var tree = utils.parseWeneedCodes(acct.documents_requested_options_desc);
            buildWeneedTree(tree, this.nodes, acct, 1, i);
        });

        this.allWeneedCodes = allWeneedCodes = allWeneedCodes.join(',');

        return DocUploadService.createDocument(flow.config, flow.req)
            .then(resp=>{

                const widgetOptions = resp.widget_options;
                if(widgetOptions){
                    flow.widgetOptions = widgetOptions;

                    flow.allDocOptions = [];
                    flow.widgetOptions.forEach((widgetOption)=> {

                        widgetOption.title = widgetOption.content_id + '.title';
                        widgetOption.desc = widgetOption.content_id + '.desc';
                        // convert to old data structure
                        var docOptions = [];
                        widgetOption.document_types.forEach(dt=>{
                            docOptions.push(dt.document_option);
                            if(dt.document_option === 'DocUpload'){
                                widgetOption.document_type = dt.document_type;
                            }
                        });
                        widgetOption.docOptions = docOptions;
                        //widgetOption.doc_options.split(/,/).map(s=>s.trim());

                        //widgetOption.code
                        utils.mergeArray(flow.allDocOptions, docOptions);
                    });

                    // set up data associations
                    utils.goOverFlowNodes(flow.nodes, node=>{
                        node.widgetOption = utils.findArray(flow.widgetOptions, o=>(o.code === node.code));
                    });

                    flow.currLevelNodes = flow.nodes;
                    flow.currNodeIndex = flow.currLevelNodes.length > 0? 0: -1;

                    return resp;
                }else{
                    throw new Error('no widget_options');
                }
            });
    }

    getCurrentNode(){
        if(!this.currNode){
            this.currNode = this.currLevelNodes[0];
        }
        return this.currNode;
    }

    getCurrentLevel(){
        return this.stack.length + 1;
    }

    getNodeIndex(node){
        for(var i=0;i<this.currLevelNodes.length;i++){
            if(node === this.currLevelNodes[i]){
                return i;
            }
        }
        return -1;
    }

    prev(){
        var index = this.getNodeIndex(this.currNode);
        if(index > 0){
            this.currNode = this.currLevelNodes[index - 1];
        }else if( this.stack.length > 0){
            this.up();
            this.prev(); // move to the next at the upper level
        }
    }

    next(){
        var index = this.getNodeIndex(this.currNode);
        if(0 <= index && index < this.currLevelNodes.length - 1){
            this.currNode = this.currLevelNodes[index + 1];
        }else if( this.stack.length > 0){
            this.up();
            this.next(); // move to the next at the upper level
        }
    }

    up(){
        if(this.stack.length > 0){
            var prev = this.stack.shift();
            this.currLevelNodes = prev.nodes;
            this.currNode = this.currLevelNodes[prev.index];
        }
    }

    down(index){
        var currNode = this.currNode;
        if(currNode && currNode.choices && 0 <= index && index < currNode.choices.length){
            this.stack.unshift({
                index: this.getNodeIndex(currNode),
                nodes: this.currLevelNodes
            });

            this.currLevelNodes = currNode.choices[index];
            this.currNode = this.currLevelNodes[0];
        }
    }


    setCurrentNode(node){
        this.currNode = node;
    }

    addMessage(text, errorKey){
        if(this.currNode){
            this.addNodeMessage(this.currNode, text, errorKey);
        }
    }

    addMessageToCurrentNode (message) {
        const { messages } = this.currNode;

        if (Array.isArray(messages)) {
            messages.push(`!${message}`);
        }
    }

    addNodeMessage(node, err, errorKey){
        const { message, errorKey: derivedErrorKey } = utils.convertError(err);
        node.messages.push('!' + message);

        trackError(errorKey || derivedErrorKey);

        // notify the invoker
        this.raiseInvokerEvent("message", message);
    }

    raiseInvokerEvent(eventName, eventValue, formattedYodleeMetadata){
        if(typeof this.widgetCallback === 'function'){
            if(eventName === 'message'){
                return this.widgetCallback({
                    event_name: eventName,
                    event_value: eventValue,
                    //error_code:  this.lastError,  //for later extension when error codes are defined.
                    submission_channel_code: this.lastChannel,
                    documents_requested_code: this.getCurrentNode() ? this.getCurrentNode().code : '',
                });
            } else {
                let failEventBody = {}; 
                if (formattedYodleeMetadata) {
                    failEventBody = {
                        event_name: eventName,
                        event_value: eventValue,
                        yodlee_metadata: formattedYodleeMetadata,
                    }
                } else {
                    failEventBody = {
                        event_name: eventName,
                        event_value: eventValue,
                    }
                }
                return this.widgetCallback(failEventBody);
            }
        }
        return undefined;
    }

    getReadyStatus(){

        // get the min value of ready status of all nodes
        const readyStatuses = this.nodes.map(node=>getNodeReadyStatus(node));

        let readyStatus = utils.reduceArray(readyStatuses,
            (s2, s) => Math.min(s, s2),
            STATUS_COMPLETED);
        const hightestStatus = utils.reduceArray(readyStatuses,
            (s2, s) => Math.max(s, s2),
            STATUS_NOT_READY);

        // Assuming multiple we need codes are additional, if some codes are provided, we consider it as STATUS_MAYBE_READY.
        if(readyStatus === STATUS_NOT_READY && hightestStatus > STATUS_NOT_READY){
            readyStatus = STATUS_MAYBE_READY;
        }
        return readyStatus;
    }

    isYodleeOnly(){
        return this.nodes.length === 1 &&
            this.nodes[0] &&
            this.nodes[0].widgetOption &&
            this.nodes[0].widgetOption.docOptions &&
            this.nodes[0].widgetOption.docOptions.length === 1 &&
            this.nodes[0].widgetOption.docOptions[0] === 'Yodlee';
    }

    isNovaOnly() {
        return this.nodes.length === 1 &&
            this.nodes[0] &&
            this.nodes[0].widgetOption &&
            this.nodes[0].widgetOption.docOptions &&
            this.nodes[0].widgetOption.docOptions.length === 1 &&
            this.nodes[0].widgetOption.docOptions[0] === 'Nova';
    }

}

export var flow = new GetInfoFlow();



// WEBPACK FOOTER //
// ./application/src/models/flow.js